import React, { useState, useEffect } from 'react'
import styles from './DeptTab.module.scss'
import DocTable from '../../components/DocTable/DocTable'
import SearchBar from '../../components/SearchBar/SearchBar'
import { getDeptDocuments, downloadDocument } from 'service/KomurConnectionService'
import { filterDocs } from '../../utils'

export default function DeptTab({ onPreview }) {
  const [docs,   setDocs]   = useState(null)
  const [search, setSearch] = useState('')

  useEffect(() => {
    getDeptDocuments()
      .then(r => setDocs(r.data))
      .catch(() => setDocs([]))
  }, [])

  const handleDownload = (_docType, id, fileName) => {
    downloadDocument(id).then(r => {
      const a = document.createElement('a')
      a.href = r.data.file_url
      a.download = fileName || 'document'
      a.click()
    }).catch(() => {})
  }

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Документы отдела</h3>
      <SearchBar value={search} onChange={setSearch} placeholder="Поиск по сотруднику или документу…" />
      <DocTable
        docs={filterDocs(docs, search)}
        showOwner
        onDownload={handleDownload}
        onPreview={onPreview}
      />
    </div>
  )
}
